/**
 * 用户管理接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;

   //钉钉相关
   out:string = environment.outWebAPI
 
   //任务调度微服务api
   activitiWebAPI: string = environment.activitiWebAPI;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 用户管理接口
  /**
   * 分页查询用户管理
   * @param param
   * @returns {Observable<any>}
   */
  queryUserPageList(param) {
    const url = this.prefix + 'user/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据岗位查用户
   * @param param
   * @returns {Observable<any>}
   */
  queryUserByPositionId(param) {
    const url = this.prefix + 'user/queryUserByPositionId';
    return this.http.Post(url, param);
  }

  /**
   * 根据角色查用户
   * @param param
   * @returns {Observable<any>}
   */
  queryUserByRoleId(roleId, systemId) {
    const url = this.prefix + 'user/queryUserByRoleId?roleId=' + roleId + "&systemId=" + systemId
    return this.http.Post(url, null);
  }

  /**
   * 修改,启用，禁用用户管理
   * @param param
   * @returns {Observable<any>}
   */
  updateUser(param) {
    const url = this.prefix + 'user/updateStatusById';
    return this.http.Post(url, param);
  }

  /**
   * 删除用户管理
   * @param param
   * @returns {Observable<any>}
   */
  deleteUser(param) {
    const url = this.prefix + 'user/deleteBatch';
    return this.http.Post(url, param);
  }
  
  /**
   * 根据角色编号查询用户列表
   * @param roleCode 
   * @param systemId 
   */
  queryUserListByRoleCode(roleCode, systemCode, systemId) {
    const url = this.prefix + 'user/queryUserListByRoleCode?roleCode=' + roleCode + "&systemCode=" + systemCode + "&systemId=" + systemId;
    return this.http.Get(url, null);
  }

  /**
   * 查询单个用户管理
   * @param param
   * @returns {Observable<any>}
   */
  getUser(param) {
    const url = this.prefix + 'user/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 同步至钉钉
   * @param param
   * @returns {Observable<any>}
   */
  synchronizeFunction(userId) {
    const url = this.prefix + 'user/synchronizeUserToDingtalkById?userId='+userId;
    return this.http.Post(url,{});
  }

  /**
   * 保存用户管理
   * @param param
   * @returns {Observable<any>}
   */
  saveUser(param) {
    const url = this.prefix + 'user/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改用户管理
   * @param param
   * @returns {Observable<any>}
   */
  updateUserById(param) {
    const url = this.prefix + 'user/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 重置密码
   * @param param
   * @returns {Observable<any>}
   */
  resetPwdUser(param) {
    const url = this.prefix + 'user/resetPwd';
    return this.http.Post(url, param);
  }

  /**
   * 空缺岗位（岗位设置）
   * @param param
   * @returns {Observable<any>}
   */
  queryEmptyPosition(param) {
    const url = this.prefix + 'position/queryEmptyPosition';
    return this.http.Post(url, param);
  }

  /**
   * 查询岗位（岗位设置）
   * @param param
   * @returns {Observable<any>}
   */
  queryPositionsByUserId(param) {
    const url = this.prefix + 'position/queryPositionsByUserId';
    return this.http.Post(url, param);
  }

  /**
   * 左侧树
   * @param param
   * @returns {Observable<any>}
   */
  queryTreeNode(param) {
    const url = this.prefix + 'organize/queryTreeNode';
    return this.http.Post(url, param);
  }

  /**
   * 查询所有第三方合作方
   * @param param
   * @returns {Observable<any>}
   */
  queryAllPartners(param) {
    const url = this.prefix + 'partner/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据用户查询第三方合作方
   * @param param
   * @returns {Observable<any>}
   */
  queryPartnersByUserId(param) {
    const url = this.prefix + 'userPartner/queryByFk';
    return this.http.Post(url, param);
  }

  /**
   * 保存第三方用户
   * @param param
   * @returns {Observable<any>}
   */
  savePartnersByUserId(param) {
    const url = this.prefix + 'userPartner/saveOrDelete';
    return this.http.Post(url, param);
  }

  /**
   * 解锁
   * @param param
   * @returns {Observable<any>}
   */
  unlock(param) {
    const url = this.prefix + 'user/unlock';
    return this.http.Post(url, param);
  }

  /**
   * 修改是否允许租户登录
   * @param param 
   */
  updateEnable(param) {
    const url = this.prefix + 'userSystem/updateEnable';
    return this.http.Post(url, param);
  }

  /**
   * 检测是否与钉钉同步
   * @param param 
   */
  querySynchronizedWithDD(param) {
    const url = this.out + 'dingtalk/getDingTalkUser?agentId=' + environment.dingTalkAgentId;
    return this.http.Post(url, param);
  }

  /**
   * 将已同步至钉钉的用户移除
   * @param param 
   */
  deleteDingtalkUser(param) {
    const url = this.out + 'dingtalk/deleteDingtalkUser?agentId=' + environment.dingTalkAgentId;
    return this.http.Post(url, param);
  }

  /**
   * 无管理权限获取所有用户
   * @param param
   * @returns {Observable<any>}
   */
  queryList(param) {
    const url = this.activitiWebAPI + 'user/queryUserList';
    return this.http.Post(url, {});
  }
  //#endregion


}
